export default "__VITE_ASSET__hL3r4oKQ__"